import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { lmLogoWhite, closeMenuIcon } from '../assets/superAdminAssets';
import { lineLoader, timeIcon } from '../assets/superAdminAssets';
import { useSelector } from 'react-redux';

const SideNavigation = () => {
  const location = useLocation();
  const timeToLogout = useSelector(state => state.user.timeToLogout);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="main-side-panel">
      <div className='panel'>
        <div className="close-panel">
          <img src={closeMenuIcon} alt="" />
        </div>
        <Link className="main-logo" to="/dashboard">
          <img src={lmLogoWhite} alt="Loan Mantra" />
        </Link>
        <div className="panel-navigation">
          <Link to="/dashboard" className={`panel-nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
            <i className="lm-dashboard-icon" />
            Dashboard
          </Link>
          <Link to="/companies" className={`panel-nav-item ${isActive('/companies') ? 'active' : ''}`}>
            <i className="lm-users-icon" />
            Companies
          </Link>
          <Link to="/plans" className={`panel-nav-item ${isActive('/plans') ? 'active' : ''}`}>
            <i className="lm-logs-icon" />
            Subscription Plans
          </Link>
          <Link to="/payments" className={`panel-nav-item ${isActive('/payments') ? 'active' : ''}`}>
            <i className="lm-templates-icon" />
            Payments
          </Link>
          <hr />
          <Link to="/settings" className={`panel-nav-item ${isActive('/settings') ? 'active' : ''}`}>
            <i className="lm-settings-icon" />
            Settings
          </Link>
        </div>
        <div className="copyright-sec">
          <p>© 2026. All right reserved.</p>
          <a href="https://loanmantra.com/privacy-policy/" target="_blank">Privacy Policy</a>
        </div>
      </div>
      <div className="session-timer">
        <div className='d-flex align-items-center gap-6px'>
          <img src={timeIcon} alt="Time Icon" width={14.4} height={14.4} />
          <span>
            Session timeout in <span className='session-time'>{!timeToLogout ? <img src={lineLoader} width={15} /> : timeToLogout}</span> minutes
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideNavigation;
